"use client";
import hljs from "highlight.js";
import React, { useEffect } from "react";
import SubscribeCard from "~/components/subscribe-card-client";
import "highlight.js/styles/github.css";
import { createRoot } from "react-dom/client";
import dynamic from "next/dynamic";
import { MyResponsiveScatterPlot } from "~/components/charts/dot";
import { charts } from "~/data/chart-data";
import { LinkTrackers } from "~/components/reusables/link-trackers";
import { QRNGBannerSM } from "../qrng-banner-sm";

const GistComponent = dynamic(
  () => import("components/pages/blog/gist/GistComponent"),
  { ssr: false },
);
const MainBlogContent = ({ blog, subscribeCard, QRNGData }) => {
  useEffect(() => {
    // Highlight all code blocks
    hljs.highlightAll();

    // Handle Gist placeholders
    const placeholders = document.querySelectorAll(".gist-placeholder");
    placeholders.forEach((placeholder) => {
      const gistId = placeholder.getAttribute("data-gist-id");
      const root = createRoot(placeholder);
      root.render(<GistComponent gistId={gistId} />);
    });

    // Handle Link trackers
    const proseElement = document.querySelector(".prose");
    if (proseElement) {
      const links = proseElement.querySelectorAll("a");
      links.forEach((link) => {
        const href = link.getAttribute("href") || "#";
        const className = link.getAttribute("class") || "";
        const target = link.getAttribute("target") || "_blank";
        const textContent = link.textContent || "";
        const isInternetOfAgentsWhitepaper =
          href ==
          "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/Internet_of_Agents_Whitepaper.pdf";

        // Manually set internet of agents tracking
        const segmentOpt = isInternetOfAgentsWhitepaper
          ? {
              link_label: textContent,
              location: "blog body",
              resource_interaction: "clicked a link",
              file_name: "Internet_of_Agents_Whitepaper.pdf",
              resource_type: "white paper",
              resource_author: "Vijoy Pandey, Ph.D",
              is_gated_asset: "false",
            }
          : {
              link_label: textContent,
              location: "blog body",
              resource_interaction: "clicked a link",
              href: href,
              resource_type: "link",
            };

        const root = createRoot(link);
        root.render(
          <LinkTrackers
            href={href}
            className={className}
            target={target}
            segmentMsg={
              isInternetOfAgentsWhitepaper
                ? "Downloadable clicked"
                : "Blog link clicked"
            }
            segmentOpt={segmentOpt}
          >
            {textContent}
          </LinkTrackers>,
        );
      });
    }

    charts.forEach(({ elementId, data }) => {
      const chartElement = document.querySelector(elementId);
      if (chartElement) {
        const root = createRoot(chartElement);
        root.render(
          <div className="h-96 w-full lg:pt-12">
            <h6 className="font-h6 mx-auto text-center">{data[0]?.id}</h6>
            <MyResponsiveScatterPlot data={data} />
          </div>,
        );
      }
    });
  }, []);
  return (
    <div className="container flex flex-col-reverse gap-10 pt-10 md:flex-row">
      {blog.key ===
      "unlocking-power-true-randomness-Cisco-quantum-random-number-generator1" ? (
        <div className="mt-8 hidden w-full md:block md:w-[250px] xl:w-[300px]">
          <QRNGBannerSM QRNGData={QRNGData} />
        </div>
      ) : (
        <div className="mt-8 hidden w-full md:block md:w-[250px] xl:w-[300px]">
          <SubscribeCard
            size="blog"
            subscribeCard={subscribeCard}
            segmentOpt={{
              link_label: "Subscribe to our newsletter",
              location: "body",
              location_detail: "left-body",
              resource_interaction: "view newsletter subscription form",
            }}
          />
        </div>
      )}
      <div className="w-full flex-1">
        {blog?.section?.map((section) => {
          return (
            <div
              className="prose max-w-full"
              dangerouslySetInnerHTML={{
                __html: section.content,
              }}
              key={`${section.id}-${section.chapter}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MainBlogContent;
